export const Order = {
  DESC: 'DESC',
  ASC: 'ASC',
}
